var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDoubleCheck = function SvgDoubleCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.034 9.94a.567.567 0 0 1 .801.8l-7.076 7.075a.566.566 0 0 1-.801 0L12.543 16.4a.566.566 0 0 1 .8-.8l1.015 1.015zm-3.773-3.774a.567.567 0 0 1 .8.8L7.684 17.344a.566.566 0 0 1-.8 0l-4.718-4.717a.566.566 0 1 1 .8-.8l4.317 4.316z"
  })));
};
export default SvgDoubleCheck;